const hostname = window.location.hostname;
const origin = window.location.origin;
const { REACT_APP_ENV, REACT_APP_PROFILE } = process.env;

export const getSettingsForEnvironment = (environment?: string, profile = "playsafely") => {
  if (profile !== "playsafely" && profile !== "coachsafely") {
    throw new Error(`Unsupported application profile: ${profile}`);
  }
  if (profile === "coachsafely") {
    switch (environment) {
      case "local": return require("./.generated/local.coachsafely.settings.json");
      case "development": return require("./.generated/dev.coachsafely.settings.json");
      case "productionlocal": return require("./.generated/prod.local.coachsafely.settings.json");
      default: return require("./.generated/prod.coachsafely.settings.json");
    }
  }
  switch (environment) {
    case "local": return require("./.generated/local.settings.json");
    case "development": return require("./.generated/dev.settings.json");
    case "productionlocal": return require("./.generated/prod.local.settings.json");
    default: return require("./.generated/prod.settings.json");
  }
};

const current_settings = getSettingsForEnvironment(REACT_APP_ENV, REACT_APP_PROFILE);

export const getCookieDomain = (currentHostname: string) => {
  if (currentHostname.endsWith(".coachsafely.org")) return ".coachsafely.org";
  if (currentHostname.endsWith(".playsafelysports.com")) return ".playsafelysports.com";
  return currentHostname;
};
const cookieDomain = getCookieDomain(hostname);

export const awsConfig = {
  ...current_settings.awsConfig,
  cookieStorage: {
    ...current_settings.awsConfig.cookieStorage,
    domain: cookieDomain,
    path: current_settings.awsConfig.cookieStorage?.path || "/",
    secure: window.location.protocol === "https:",
  },
  ...(current_settings.awsConfig.oauth ? { oauth: {
    ...current_settings.awsConfig.oauth,
    redirectSignIn: origin,
    redirectSignOut: origin,
  } } : {}),
};

export const HOST = current_settings.HOST;
export const PLATFORM_HOST = current_settings.PLATFORM_HOST;
export const BACKGROUND_HOST = current_settings.BACKGROUND_HOST;

export const ALLOW_IMGCACHE = false;

export const stripe_public_key = current_settings.stripe_public_key;

export const mapboxgl_accessToken = current_settings.mapboxgl_accessToken;
